import { useEffect, useMemo, useState } from "react";
import {
    TResponse,
    IPromptRequest,
    IMessagePart,
    IMessagePageContent,
} from "./interface/data";

import useWebSocket from "react-use-websocket";

const wssUrl = process.env.REACT_APP_WEBSOCKET_URL;
const wssUrlError = process.env.REACT_APP_WEBSOCKET_ERROR_URL;
const wssUrlDiscover = process.env.REACT_APP_WEBSOCKET_DISCOVER_URL;
const DataService = {
    usePrompt: (location: string) => {
        const endpoint = useMemo((): string => {
            if (location === "/discover") {
                return wssUrlDiscover!;
            }
            if (location === "/error") {
                return wssUrlError!;
            }
            return wssUrl!;
        }, [location]);

        const [requestMessage, setRequestMessage] = useState<IPromptRequest>();
        const { sendJsonMessage, readyState, lastJsonMessage } = useWebSocket(
            endpoint!,
            {
                // onOpen: () => {
                //     console.log("socket opened");
                // },
                shouldReconnect: (closeEvent) => true,
            }
        );

        useEffect(() => {
            if (!requestMessage) {
                return;
            }

            sendJsonMessage(requestMessage);
        }, [requestMessage, sendJsonMessage]);

        return {
            response: lastJsonMessage as TResponse<IMessagePart | IMessagePageContent>,
            setRequestMessage,
            readyState,
        };
    },
};

export default DataService;
